/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { ILaborIncident } from 'app/shared/model/labor-incident.model';

export interface IGynaecChecklist {
  id?: string;
  motherAntibiotics?: boolean | null;
  mChills?: boolean | null;
  mFsvd?: boolean | null;
  mLat?: boolean | null;
  mLateRuptureOfMembranes?: boolean | null;
  mDelayedLabour?: boolean | null;
  bAntibiotics?: boolean | null;
  bAbnormalBreathing?: boolean | null;
  bChestGrunting?: boolean | null;
  bConvulsions?: boolean | null;
  bLooksSick?: boolean | null;
  bTooCold?: boolean | null;
  bTooHot?: boolean | null;
  bStoppedFeeding?: boolean | null;
  bExcessiveCrying?: boolean | null;
  bUmblicalRedness?: boolean | null;
  mBleedingControlled?: boolean | null;
  bFeedingNormal?: boolean | null;
  bNotes?: string | null;
  mNotes?: string | null;
  active?: boolean | null;
  cursor?: number;
  lastupdated?: number | null;
  microSec?: number | null;
  timestampentry?: number | null;
  patient?: IGlucoUser;
  incident?: ILaborIncident | null;
}

export const defaultValue: Readonly<IGynaecChecklist> = {
  motherAntibiotics: false,
  mChills: false,
  mFsvd: false,
  mLat: false,
  mLateRuptureOfMembranes: false,
  mDelayedLabour: false,
  bAntibiotics: false,
  bAbnormalBreathing: false,
  bChestGrunting: false,
  bConvulsions: false,
  bLooksSick: false,
  bTooCold: false,
  bTooHot: false,
  bStoppedFeeding: false,
  bExcessiveCrying: false,
  bUmblicalRedness: false,
  mBleedingControlled: false,
  bFeedingNormal: false,
  active: false,
};
